import React from 'react'

const Disclaimer = () => {
    return (
        <div className="disclaimer"><span className="bold">Note:</span> All data is from the last 30 days</div>
    )
}

export default Disclaimer